export default __webpack_public_path__ + "static/media/holidays-logo.a2020e5e.svg";